export async function cacheUserAssets(accessToken: string | null | undefined) {
  if (!accessToken) return;

  if ("serviceWorker" in navigator) {
    try {
      const registration = await navigator.serviceWorker.register("/sw.js");

      // Wait until the service worker is active and send a message
      if (navigator.serviceWorker.controller) {
        navigator.serviceWorker.controller.postMessage({
          type: "CACHE_AUTHENTICATED_ASSETS",
          token: accessToken,
        });
      } else {
        // Handle cases where controller is null on first load
        navigator.serviceWorker.addEventListener("controllerchange", () => {
          navigator.serviceWorker.controller?.postMessage({
            type: "CACHE_AUTHENTICATED_ASSETS",
            token: accessToken,
          });
        });
      }
    } catch (error) {
      console.error("Service Worker registration failed:", error);
    }
  }
}

export function clearCachedUserAssets() {
  try {
    if ("serviceWorker" in navigator && navigator.serviceWorker.controller) {
      navigator.serviceWorker.controller.postMessage({
        type: "CLEAR_CACHED_AUTHENTICATED_ASSETS",
      });
    }
  } catch (err) {}
}
